<template>
  <drag-modal :visible="visible" @cancel="reset" :title="edit ? '编辑函件信息' : '新增函件信息'" width='840px'>
    <div class="lawsuit">
      <a-form-model ref="forms" :model="form" :rules="rules" :label-col="{ span: 10 }" :wrapper-col="{ span: 24 }">
        <a-form-model-item label="函件类型" prop="letters_type"
          :rules="{ required: true, message: '请选择函件类型', trigger: 'change' }" :label-col="{ span: 3 }"
          :wrapper-col="{ span: 10 }">
          <a-select placeholder="请选择函件类型" v-model="form.letters_type">
            <a-select-option :value="i.id" v-for="(i, index) in typeList" :key="index">
              {{ i.label }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="函件名称" prop="title" :rules="{ required: true, message: '请输入函件名称', trigger: 'blur' }"
          :label-col="{ span: 3 }" :wrapper-col="{ span: 10 }">
          <a-input type="text" v-model="form.title" placeholder="请输入"></a-input>
        </a-form-model-item>
        <a-form-model-item label="函号" prop="no" :rules="{ required: true, message: '请输入函号', trigger: 'blur' }"
          :label-col="{ span: 3 }" :wrapper-col="{ span: 10 }">
          <a-input type="text" v-model="form.no" placeholder="请输入"></a-input>
        </a-form-model-item>
        <a-form-model-item label="委托人" prop="accuser_id"
          :rules="{ required: true, message: '请选择委托人', trigger: 'change' }" :label-col="{ span: 3 }"
          :wrapper-col="{ span: 10 }">
          <a-select v-model="form.accuser_id" placeholder="请选择" class="select" :maxTagCount='1' :maxTagTextLength='12'>
            <a-select-option v-for="item in accuserList" :key="item.title" :value="item.id">{{ item.title
            }}</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="接收人" prop="receiver_debtor_id"
          :rules="{ required: true, message: '请选择接收人', trigger: 'change' }" :label-col="{ span: 3 }"
          :wrapper-col="{ span: 10 }">
          <a-select v-model="form.receiver_debtor_id" placeholder="请选择" class="select" :maxTagCount='1'
            :maxTagTextLength='12'>
            <a-select-option v-for="item in letters_debtor" :key="item.name" :value="item.id">{{ item.name
            }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item prop="files" :rules="{ required: true, message: '请上传附件', trigger: 'change' }"
          style='margin:0;'>
          <Upload @isDisabled="parentHandle" :fList='form.files' @upFileAfter='lisUpload' :Wid='"98px"'
            :repuired='true' />
        </a-form-model-item>
        <div class="likebox">
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-model-item label="单号" prop="ship_no"
                :rules="{ required: true, message: '请输入单号', trigger: 'blur' }">
                <a-input v-model="form.ship_no" />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="联系方式" prop="tel"
                :rules="[{ required: true, message: '请输入联系方式', trigger: 'blur' }, { validator: Validator.validateContact, trigger: 'blur' }]">
                <a-input v-model="form.tel" :maxLength="20" />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="材料名称" prop="filename"
                :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                <a-input v-model="form.filename" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-model-item label="收件人" prop="receive_name"
                :rules="{ required: true, message: '请输入收件人', trigger: 'blur' }">
                <a-input v-model="form.receive_name" />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="寄出时间" prop="ship_time"
                :rules="{ required: true, message: '请选择寄出时间', trigger: 'change', }">
                <a-date-picker v-model="form.ship_time" placeholder="请选择" show-time type="date"
                  valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" style="width: 100%" />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="">
                <a-radio-group v-model="gout" style="white-space: nowrap" size="small">
                  <a-radio-button :value="null"
                    style="width: 64px;text-align: center;font-size: 0.75rem;">无</a-radio-button>
                  <a-radio-button :value="'a'"
                    style="width: 65px;text-align: center;font-size: 0.75rem;">签收时间</a-radio-button>
                  <a-radio-button :value="'b'"
                    style="width: 65px;text-align: center;font-size: 0.75rem;">拒收时间</a-radio-button>
                </a-radio-group>
                <a-date-picker v-model="form.receive_time" placeholder="请选择" show-time type="date"
                  valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" v-if="gout == 'a'"
                  style="width: 100%" />
                <a-date-picker v-model="form.return_time" placeholder="请选择" show-time type="date"
                  valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" style="width: 100%"
                  v-if="gout == 'b'" />
                <a-input disabled v-if="!gout" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item label="收件地址" prop="addr"
                :rules="{ required: true, message: '请输入收件地址', trigger: 'blur' }">
                <a-input v-model="form.addr" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="备注" prop="comment"
                :rules="{ required: false, message: '请输入备注', trigger: 'blur', }">
                <a-input v-model="form.comment" />
              </a-form-model-item>
            </a-col>
          </a-row>

        </div>
        <a-form-model-item style="text-align:center;">
          <a-popconfirm :disabled="disabledShow" title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="confirm">
            <a-button :disabled="disabledShow" type="primary" style="width:148px;">
              提交
            </a-button>
          </a-popconfirm>
          <a-button style=" margin-left: 20px;width:148px;background:#B2C9E1;color:#fff;" @click='reset'>取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
  </drag-modal>
</template>
<script>
import Validator from "@/assets/js/yz.js"
import { letters_type } from './keys'
import { getAccuserAll, Ldebtor } from '@/server/api'
import Upload from "@/components/uploads"
import Filesee from '@/components/filesee'
import { lawKeys } from './keys'
export default {
  props: {
    info: {
      type: Object,
      default() {
        return {

        }
      }
    },
    letters_debtor: Array
  },
  components: {
    Upload
  },
  watch: {
    info: {
      handler(newVal) {
        if (newVal.id) {
          let form = {}
          lawKeys.map(ele => {
            form[ele] = newVal[ele]
          })
          if (!form.receive_time && !form.return_time) {
            this.gout = null
          } else {
            if (form.receive_time) {
              this.gout = 'a'
            } else {
              this.gout = 'b'
            }
          }
          this.form = form
          this.edit = true
        } else {
          this.form = { files: [] }
          this.edit = false
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      Validator,
      gout: null,
      edit: false,
      visible: false,
      accuserList: [],
      rules: {},
      typeList: letters_type,
      form: {
        files: []
      },
      disabledShow: false
    }
  },
  mounted() {
    getAccuserAll().then((res) => {
      this.accuserList = res.list
    })
  },
  methods: {
    parentHandle(data) {
      this.disabledShow = data
    },
    confirm() {
      this.$refs.forms.validate(valid => {
        if (valid) {
          let form = JSON.parse(JSON.stringify(this.form));
          if (this.gout == "a") {
            delete form.return_time
          } else if (this.gout == "b") {
            delete form.receive_time
          } else {
            delete form.return_time
            delete form.receive_time
          }
          form.files = form.files.map(ele => {
            return ele.id || ele
          })
          form.letters_debtor_id = this.$route.params.id
          Ldebtor(this.edit ? 'edit' : 'add', form).then(() => {
            this.$message.success((this.edit ? '修改' : '新增') + '成功')
            this.$emit('resh')
            this.reset()
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    lisUpload(fileList) {
      this.form.files = fileList
    },
    reset() {
      this.gout = null
      this.$refs.forms.resetFields()
      this.visible = false
    }
  }
}
</script>
<style lang='less' scoped>
.likebox {
  padding: 20px;
  background: #f3f6fb;
  margin-bottom: 30px;
  border-radius: 8px;

  /deep/ .ant-form-item-label {
    text-align: left;
  }

  /deep/ .ant-form-item {
    margin: 0;
  }

  .htit {
    font-size: 1rem;
    color: #0e2949;
    line-height: 19px;
    margin-bottom: 12px;

    span {
      color: #f00;
      cursor: pointer;
    }
  }
}
</style>